import { WithPopover, Wrapper } from '@american-autonomy/ag-ui';

import ContextMenuIcon from 'components/icons/ContextMenuIcon';

import { DROPDOWN_DIRECTION, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewCardHeaderDropdown: FunctionComponent<Props> = ({
    children,
    className = '',
    isDisabled = false,
    testId = TEST_ID
}) => {
    if (isDisabled) {
        return (
            <Wrapper className={`${className} ${styles.disabledTrigger}`} testId={testId}>
                <ContextMenuIcon className={styles.contextMenuIcon} />
            </Wrapper>
        );
    }

    return (
        <WithPopover
            className={`${className} ${styles.withPopover}`}
            direction={DROPDOWN_DIRECTION}
            testId={testId}
            trigger={<ContextMenuIcon className={styles.contextMenuIcon} />}>
            <Wrapper className={styles.wrapper}>{children}</Wrapper>
        </WithPopover>
    );
};

export default DetailsViewCardHeaderDropdown;
